export default __webpack_public_path__ + "static/media/2_zvuk.06c595ba.wav";